import { render } from "./AttendanceList.vue?vue&type=template&id=faa60766"
import script from "./AttendanceList.vue?vue&type=script&lang=js"
export * from "./AttendanceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__